// src/pages/AboutPage.tsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useCurrentLang } from "../hooks/useCurrentLang";
import { aboutPageContent } from "../data/aboutPageContent";
import image from "../images/p-page.png";
import GlassCard from "../components/GlassCard";

export const AboutPage = ({lang = "en"}) => {
  const currentLang = useCurrentLang();
  const t = aboutPageContent[currentLang]

  return (
    <div className="page page--about">
      <Header lang={currentLang}/>

      <main>
        {/* HERO */}
        <section className="page-section page-section--hero">
          <div className="content-narrow">
            <div className="glass-card glass-card--hero">
              <div className="about-hero-layout">
                <div>
                  <p className="eyebrow">{t.aboutUPPER}</p>
                  <h1>{t.aboutRevimo}</h1>
                  <p className="hero-lead" style={{color: "var(--text-muted)"}}>
                    {t.aboutDescription}
                  </p>
                </div>

                <div className="about-hero-media" style={{overflow: "hidden"}}>
                  {/* Optional hero image later */}
                  <img src={image} alt="Revimo in use" style={{width: "100%", height: "100%", maxHeight: "180px", objectFit: "cover",objectPosition: "center"}}/>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* OUR STORY + AT A GLANCE */}
        <section className="page-section page-section--about-main">
          <div className="content-narrow about-layout about-layout--balanced">
            <article className="glass-card about-card">
              <h2>{t.ourStory}</h2>
              <p style={{color: "var(--text-muted)"}}>
               {t.ourStoryShort}
              </p>
              <p>

              </p>
            </article>

            <GlassCard>
              <h2>{t.atGlance.title}</h2>
              <ul className="about-stats">
                <li>
                  <span className="label">{t.atGlance.label.founded}</span>
                  <span className="value">2026</span>
                </li>
                <li>
                  <span className="label">{t.atGlance.label.headquarters}</span>
                  <span className="value">{t.atGlance.value.headquarters}</span>
                </li>
                <li>
                  <span className="label">{t.atGlance.label.coreFocus}</span>
                  <span className="value">{t.atGlance.value.coreFocus}</span>
                </li>
                <li>
                  <span className="label">{t.atGlance.label.costumers}</span>
                  <span className="value">{t.atGlance.value.costumers}</span>
                </li>
                <li>
                  <span className="label">{t.atGlance.label.markets}</span>
                  <span className="value">{t.atGlance.value.markets}</span>
                </li>
              </ul>
            </GlassCard>
          </div>
        </section>

        {/* MISSION / VISION / VALUES */}
        <section className="page-section page-section--mvv">
          <div className="content-narrow">
            <div className="glass-card mvv-card mvv-card--grouped">
              <h2>{t.eTitle}</h2>
              <div className="mvv-grid-inline">
                <p style={{color: "var(--text-muted)"}}>{t.ourStory1}</p>
                <p style={{color: "var(--text-muted)"}}>{t.ourStory2}</p>
                <div className="mvv-item">
                  <h3>{t.Omission}</h3>
                  <p style={{color: "var(--text-muted)"}}>
                   {t.mission}
                  </p>
                </div>
                <div className="mvv-item">
                  <h3>{t.Ovision}</h3>
                  <p style={{color: "var(--text-muted)"}}>
                    {t.vision}
                  </p>
                </div>
                <div className="mvv-item">
                  <h3>{t.Ovalues}</h3>
                  <ul>
                    <li style={{color: "var(--text-muted)"}}>{t.values.wellbeing}</li>
                    <li style={{color: "var(--text-muted)"}}>{t.values.healthyMovement}</li>
                    <li style={{color: "var(--text-muted)"}}>{t.values.accessibility}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TEAM */}
        {/**  
        <section className="page-section page-section--team">
          <div className="content-narrow">
            <div className="team-header">
              <h2>People behind Revimo</h2>
              <p>
                Short line about the team – why your expertise and motivation
                make Revimo trustworthy.
              </p>
            </div>

            <div className="team-layout">
              <div className="team-media glass-card">
                {/* Optional team photo */}
                {/* <img src="/images/team.jpg" alt="Revimo team" /> 
              </div>

              <div className="team-list">
                <div className="glass-card team-member">
                  <h3>Name Surname</h3>
                  <p className="role">Role / Position</p>
                  <p className="bio">
                    1–2 sentence bio focusing on experience and what they bring
                    to Revimo.
                  </p>
                </div>
                {/* Add more team-member cards as needed 
              </div>
            </div>
          </div>
        </section>*/}
      </main>

      <Footer lang={currentLang}/>
    </div>
  );
};
